<template>
  <div class="userSetting">
  <div class="title">
    <p class="merchant">商户名称</p>
    <p class="mechantName">{{merchantName}}</p>
  </div>
  <div class="messagePush cf">
    <span class="messagePushText fl">{{messagePush}}</span>
    <span class="messagePushSwith on fr" v-show="on" @click="swith(0)"></span>
    <span class="messagePushSwith off fr" v-show="!on" @click="swith(1)"></span>
  </div>
  <button class="signOut" @click="signOutFn">{{signOut}}</button>
   <!-- <tab></tab>   -->
  </div>
</template>
<script>
import Tab from 'components/tab'
import dataHeader from 'components/dataHeader'
import { MessageBox } from 'mint-ui'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      merchantName: '深圳旗鱼餐饮管理有限公司',
      messagePush: '是否接收已支付订单消息推送',
      signOut: '退出登录',
      on: true
    }
  },
  components: {
    Tab,
    dataHeader
  },
  mounted() {
    this.getMessagePushFn()  // 获取推送开关的状态
  },
  computed: {
    resturantId: function() {
      return this.$store.state.resturantId
    }
  },
  methods: {
    ...mapActions([
      'resetStore'
    ]),
    swith(value) {
      const _this = this
      this.$http.get(this.common.url_user + '/updatePaidOrderPush', {
        params: {
          userId: _this.common.localGet('loginInfo').userId,
          merchantId: _this.common.localGet('loginInfo').merchantId,
          restaurantId: _this.resturantId,
          paidOrderPush: value,
          openId: _this.common.localGet('openId')
        }
      })
      .then(function(response) {
        if (response.data.code === 0) {
          _this.on = !_this.on
          console.log(response.data)
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        console.log('错误的请求' + error)
      })
    },
    signOutFn() {
      // MessageBox({
      //   title: '提示',
      //   message: '你确认退出旗鱼算账宝吗？退出后将不再接受平台每日早上7点钟的营业数据推送。',
      //   showCancelButton: true,
      //   confirmButtonClass: 'confirmBtn',
      //   cancelButtonClass: 'cancleBtn',
      //   closeOnClickModal: true,
      //   confirmButtonHighlight: true,
      //   cancelButtonHighlight: true
      // })
      MessageBox.confirm('你确认退出旗鱼算账宝吗？退出后将不再接受平台每日早上7点钟的营业数据推送。', '提示')
      .then(action => {
        const _this = this
        this.$http.get(this.common.url_user + '/managerH5Logout', {
          params: {
            userId: _this.common.localGet('loginInfo').userId,
            merchantId: _this.common.localGet('loginInfo').merchantId,
            openId: _this.common.localGet('openId')
          }
        })
        .then(function(response) {
          console.log(response)
          if (response.data.code === 0) {
            console.log(_this)
            _this.resetStore()
            _this.$router.push({ path: '/login' }) // 跳到登录页
          } else if (response.data.code === 300008) {  // 取消权限或被迫下线
            MessageBox.confirm('', {
              message: response.data.msg,
              title: '提示',
              confirmButtonText: '确定',
              showCancelButton: false
            }).then(action => {
              if (action === 'confirm') {
                _this.$router.push({ path: '/login' })
              }
            })
          } else {
            MessageBox.confirm('', {
              message: response.data.msg,
              title: '提示',
              confirmButtonText: '确定',
              showCancelButton: false
            }).then(action => {
              if (action === 'confirm') {
                console.log(response.data.msg)
              }
            })
          }
        })
        .catch(function(error) {
          console.log('错误的请求' + error)
        })
      })
    },
    getMessagePushFn() {
      const _this = this
      this.$http.get(this.common.url_user + '/searchPaidOrderPush', {
        params: {
          userId: _this.common.localGet('loginInfo').userId,
          merchantId: _this.common.localGet('loginInfo').merchantId,
          restaurantId: _this.resturantId,
          openId: _this.common.localGet('openId')
        }
      })
      .then(function(response) {
        if (response.data.code === 0) {
          console.log(response)
          _this.merchantName = response.data.data.merchantName
          if (response.data.data.paidOrderPush === 0) {
            _this.on = false
          } else {
            _this.on = true
          }
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        console.log('错误的请求' + error)
      })
    }
  },
  watch: {
    // '$route': 'getMessagePushFn'
    // 'on': 'getMessagePushFn'
  }
}
</script>
<style scoped>
/* @import '../common/css/userSetting.css'; */
  .userSetting{
    width: 100%;
    height: 100%;
    background-color: #f1f2f3;
  }
  .tab{
    width: 100%;
  }
  .title{
    height: 3rem;
    width: 100%;
    background: url('~common/image/backpg.png') no-repeat center / 100% 100%;
  }
  .merchant{
    color: #ffffff;
    font-size: .3rem;
    text-align: center;
    padding-top: .85rem;
  }
  .mechantName{
    color: #ffffff;
    font-size: .36rem;
    text-align: center;
    font-weight: bolder;
    padding-top: .24rem;
  }
  .messagePush{
    height: .9rem;
    line-height: .9rem;
    margin-top: .2rem;
    background: #ffffff;
  }
  .messagePushText{
    font-size: .28rem;
    color: #000000;
    padding-left: .28rem;
  }
  .signOut{
    color: #000000;
    background: #ffffff;
    font-size: .28rem;
    height: .9rem;
    width: 100%;
    line-height: .9rem;
    margin-top: .3rem;
    text-align: center;
    border: 0;
  }
  .messagePushSwith{
    display: inline-block;
    width: 1.72rem;
    height: .64rem;
    margin-top: .13rem;
    margin-right: .2rem;
  }
  .messagePushSwith.on{
    background: url('~common/image/On.png') no-repeat center / 1.72rem .64rem;
  }
  .messagePushSwith.off{
    background: url('~common/image/Off.png') no-repeat center / 1.72rem .64rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/userSetting.vue